module.exports = __webpack_public_path__ + "static/img/claude.fa221ea5.svg";